<template>
    <div class="">
        <h4 class="text-center">Settings</h4>


        <div    v-if="loggingPeriodsCanBeSet()"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Seperate Minimum & Maximum</span>
            <select2    v-model:value="$data._settings['reportStyle']"
                        :close-on-select="true"
                        :options="styleOptions"
                        @input="updateSettings($event, 'reportStyle')"
            ></select2>
        </div>

        <!-- Log Time 1 -->
        <div    v-if="loggingPeriodsCanBeSet()"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Log Time 1</span>
            <date-time-picker   id="log_time_1"
                                v-model="$data._settings['logTime1']"
                                format="HH:mm"
                                @update:modelValue="updateSettings($event, 'logTime1')"
            ></date-time-picker>
        </div>

        <!-- Log Time 2 -->
        <div    v-if="loggingPeriodsCanBeSet()"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Log Time 2</span>
            <date-time-picker   id="log_time_2"
                                v-model="$data._settings['logTime2']"
                                format="HH:mm"
                                @update:modelValue="updateSettings($event, 'logTime2')"
            ></date-time-picker>
        </div>

        <!-- Logging Periods display -->
        <div    v-if="loggingPeriodsCanBeSet()">
            <h5 class="text-center">Logging Periods</h5>
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <span>Logging Period 1</span>
                <input  :value="loggingPeriod1"
                        class="py-1 px-3 text-gray-800 leading-normal rounded text-base border rounded" disabled type="text">
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <span>Logging Period 2</span>
                <input :value="loggingPeriod2"
                       class="py-1 px-3 text-gray-800 leading-normal rounded text-base border rounded" disabled type="text">
            </div>
        </div>

        <h4 class="text-center">Persistent Settings</h4>

        <!-- Include Min / Max -->
        <div class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>Include Min/Max Values</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['includeMinMax']"
                        @toggle="updateSettings($event, 'includeMinMax')"
                ></toggle>
            </div>
        </div>

        <!-- Include Dew Point -->
        <div class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>Include Dew Point</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['includeDewPoint']"
                        @toggle="updateSettings($event, 'includeDewPoint')"
                ></toggle>
            </div>
        </div>

        <!-- Include MKT -->
        <div class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>Include Mean Kinetic Temperature (MKT)</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['includeMKT']"
                        @toggle="updateSettings($event, 'includeMKT')"
                ></toggle>
            </div>
        </div>

        <!-- Include Time out of Range -->
        <div class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>Include Time Out of Range</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['includeTimeOutOfRange']"
                        @toggle="updateSettings($event, 'includeTimeOutOfRange')"
                ></toggle>
            </div>
        </div>

        <!-- Include All Readings -->
        <div class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>Include All Data</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['includeData']"
                        @toggle="updateSettings($event, 'includeData')"
                ></toggle>
            </div>
        </div>

        <!-- ShowMeVax -->
        <div v-if="$data._settings['showShowMeVax']" class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>ShowMeVax CSV Generation</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['includeShowMeVax']"
                        @toggle="updateSettings($event, 'includeShowMeVax')"
                ></toggle>
            </div>
        </div>

        <!-- Hide Graph -->
        <div v-if="$data._settings['showHideGraph']" class="grid grid-cols-2 text-center lg:grid-cols-2 my-2 lg:text-center">
            <span>Hide Graph</span>
            <div class="flex justify-center lg:justify-start">
                <toggle v-model:value="$data._settings['hideGraph']"
                        @toggle="updateSettings($event, 'hideGraph')"
                ></toggle>
            </div>
        </div>

        <h4 class="text-center">Interval Settings</h4>

        <!-- Automatic Sending Interval -->
        <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span   v-if="isSavable">Automatic Sending Interval</span>
            <span   v-else>Reporting Interval</span>
            <select2 v-model:value="$data._interval"
                     :close-on-select="true"
                     :options="intervals"
                     @input="updateSettings($event, 'interval')"
            ></select2>
        </div>

        <!-- Weekday to receive weekly reports -->
        <div    v-if="$data._interval === 'weekly' && isSavable"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Day to Receive Report</span>
            <select2 v-model:value="$data._settings['weekday']"
                     :close-on-select="true"
                     :options="weekdayOptions"
                     @input="updateSettings($event, 'weekday')"
            ></select2>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";

import Select2 from "../elements/select2";
import {Intervals} from "./Intervals";
import DateTimePicker from "../Reports/DateTimePicker";
import Toggle from "../elements/toggle";

export default {
    name: "ExcursionReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Toggle, DateTimePicker, Select2},
    props: {
        interval: {
            type: String,
            default: Intervals.MONTHLY,
        },
        settings: Object,

        // TODO. include this in JS instead
        weekdayOptions: {
            type: Object,
            default: Intervals.WEEKDAY_OPTIONS,
        },
        semiMonthOptions: {
            type: Object,
            default: Intervals.SEMI_MONTH_OPTIONS,
        },
        intervals: {
            type: Object,
            default: Intervals.INTERVAL_OPTIONS,
        },
        styleOptions: {
            type: Object,
            default() {
                return {
                    ExcursionDontSplitLog: 'By Day',
                    ExcursionSplitLog: 'By Log Period',
                }
            }
        },
        isSaving: {
            type: Boolean,
            default: false,
        },
        isSavable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            month: this.maxDate,
            format: _.indexOf(['monthly', 'semi-monthly'], this.interval) > -1 ? 'MMMM YYYY' : 'MMMM DD, YYYY',
            viewMode: _.indexOf(['monthly', 'semi-monthly'], this.interval) > -1  ? 'months' : 'days',

            selectedUsers: this.selectedUsersInput,
            selectedMeters: [],

            _settings: this.settings,

            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,

            _interval: this.interval,
            isSaving: false,
        }
    },
    created() {
    },
    mounted() {
        this.ensureSettingKeyExists('includeData', false)
    },
    methods: {
        updateSettings(event, triggeringComponent = 'Unknown') {
            // Update the settings values based on the new local
            this.$emit('update:settings', this.$data._settings)
            this.$forceUpdate()
        },
        ensureSettingKeyExists(key, defaultValue = null) {
            this.$data._settings[key] = Object.keys(this.$data._settings).indexOf(key) !== -1
                    ? this.$data._settings[key]
                    : defaultValue;
        },
        zeropadTime(value, length = 2) {
            if (!(value instanceof String)) {
                value = value.toString()
            }
            while(value.length < length) {
                value = '0' + value
            }
            return value
        },
        loggingPeriodsCanBeSet() {
            // If the daily data interval is selected, the logging periods cannot be manipulated.
            return this.$data._interval !== Intervals.DAILY_DATA
        },
    },
    computed: {
        logTime1Str() {
            if (_.isNull(this.$data._settings['logTime1'])) {
                return ''
            }

            return `${this.zeropadTime(this.$data._settings['logTime1'].getHours())}:` +
                `${this.zeropadTime(this.$data._settings['logTime1'].getMinutes())}`
        },
        logTime2Str() {
            if (_.isNull(this.$data._settings['logTime2'])) {
                return ''
            }

            return `${this.zeropadTime(this.$data._settings['logTime2'].getHours())}:` +
                `${this.zeropadTime(this.$data._settings['logTime2'].getMinutes())}`
        },
        loggingPeriod1() {
            return `${this.logTime1Str} - ${this.logTime2Str}`
        },
        loggingPeriod2() {
            return `${this.logTime2Str} - ${this.logTime1Str}`
        },
    },
    watch: {
        _interval(val, old) {
            if (val !== old) {
                this.$emit('update:interval', this.$data._interval)
            }
        },
        interval(val) {
            if (_.indexOf(['weekly'], val) > -1) {
                this.format = 'MMMM DD, YYYY'
                this.viewMode = 'days'
            }
            else if (_.indexOf(['monthly', 'semi-monthly'], val) > -1) {
                this.format = 'MMMM YYYY'
                this.viewMode = 'months'
            }
        },
    },
}
</script>

<style scoped>

</style>